export enum UpdateType {
  merge = 'merge',
  replace = 'replace',
  remove = 'remove',
}
